import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class ContainerTypeFormBaseComponent {
  containerTypeForm: FormGroup;
  errorMessage: string | null = null;

  constructor(protected fb: FormBuilder) {
    this.containerTypeForm = this.fb.group({
      name: ['', Validators.required],
    });
  }

  markAllFieldsAsTouched(): void {
    Object.keys(this.containerTypeForm.controls).forEach(field => {
      const control = this.containerTypeForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get name() {
    return this.containerTypeForm.get('name');
  }
}
